// import MenuStore from 'stores/MenuStore';
// import Account from 'stores/Account'
// import Payment from 'stores/Payment';
// import Player from 'stores/Player';
// import Content from 'stores/Content';
// import { storeContext } from 'stores/store';

const Stores = {
  // MenuStore,
  // Account,
  // Payment,
  // Player,
  // Content
};

// export const useStores = () => React.useContext(storeContext);

export default Stores;
